/**
 * Placeholder rows for the feed modals: people lists (comments, likes) and
 * plain option lists (report reasons).
 */
import { Skeleton, SkeletonGroup, skeletonKeys } from '../../components/ui/Skeleton';
import './feedModal.css';

interface CountProps {
  count?: number;
}

export function FeedUserRowsSkeleton({ count = 4 }: CountProps) {
  return (
    <SkeletonGroup className="feed-modal-skeleton">
      {skeletonKeys(count).map(key => (
        <div className="feed-modal-skeleton__row" key={key} aria-hidden>
          <Skeleton shape="circle" className="feed-modal-skeleton__avatar" />
          <div className="feed-modal-skeleton__meta">
            <Skeleton className="feed-modal-skeleton__line feed-modal-skeleton__line--name" />
            <Skeleton className="feed-modal-skeleton__line feed-modal-skeleton__line--text" />
          </div>
        </div>
      ))}
    </SkeletonGroup>
  );
}

export function FeedLinesSkeleton({ count = 5 }: CountProps) {
  return (
    <SkeletonGroup className="feed-modal-skeleton">
      {skeletonKeys(count).map(key => (
        <Skeleton className="feed-modal-skeleton__line feed-modal-skeleton__line--option" key={key} />
      ))}
    </SkeletonGroup>
  );
}
